import { render } from "./EquippedPanel.vue?vue&type=template&id=754f74ae&scoped=true"
import script from "./EquippedPanel.vue?vue&type=script&lang=js"
export * from "./EquippedPanel.vue?vue&type=script&lang=js"

import "./EquippedPanel.vue?vue&type=style&index=0&id=754f74ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754f74ae"]])

export default __exports__